module.exports = __webpack_public_path__ + "static/media/eveniment_corporate.679dbc67.jpg";